import React, { useEffect, useRef, useState } from "react";

const InlineCounter = ({
  target = 0,
  duration = 1000,
  suffix = "",
  style = {},
}) => {
  const [count, setCount] = useState(0);
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);

  useEffect(() => {
    if (!visible) {
      setCount(0);
      return;
    }
    const end = Number(target) || 0;
    if (end === 0) {
      setCount(0);
      return;
    }
    let start = 0;
    const increment = end / (duration / 90);

    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 30);

    return () => clearInterval(timer);
  }, [target, duration, visible]);

  return (
    <span
      ref={ref}
      style={{ fontSize: 30, fontWeight: 500, color: "#FFF", ...style }}
    >
      {Math.round(count)}
      {suffix}
    </span>
  );
};

export default InlineCounter;
